import React from 'react';
import { useTranslation } from 'react-i18next';

function DeleteConfirmDialog({ isOpen, onConfirm, onCancel, title }) {
  const { t } = useTranslation(['expenses', 'common']);
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="card max-w-md w-full">
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-black mb-2">{title || t('deleteConfirm.title')}</h2>
          <p className="text-lg text-gray-600">
            {t('deleteConfirm.warning')}
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="btn-secondary flex-1"
          >
            {t('common:buttons.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="btn-danger flex-1"
          >
            {t('common:buttons.delete')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmDialog;
